// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListSettingsForm-errorMessage-sVfMa {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.ListSettingsForm-space1-Q30SZ {
	margin-bottom: 6px !important;
}
.ListSettingsForm-space2-Pm2mg {
	margin-bottom: 12px !important;
}
.ListSettingsForm-space3-GNNbd {
	margin-bottom: 18px !important;
}
.ListSettingsForm-space4-Rg4fm {
	margin-bottom: 24px !important;
}
.ListSettingsForm-space5-pYGR0 {
	margin-bottom: 30px !important;
}
.ListSettingsForm-space6-e7rEM {
	margin-bottom: 36px !important;
}
.ListSettingsForm-space7-xnVyq {
	margin-bottom: 42px !important;
}
.ListSettingsForm-spaceTop8-uX6v1 {
	margin-bottom: 48px !important;
}
.ListSettingsForm-spaceTop1-P0JbT {
	margin-top: 6px !important;
}
.ListSettingsForm-spaceTop2-nMRDf {
	margin-top: 12px !important;
}
.ListSettingsForm-spaceTop3-iQWyE {
	margin-top: 18px !important;
}
.ListSettingsForm-spaceTop4-oX0Gy {
	margin-top: 24px !important;
}
.ListSettingsForm-spaceTop5-vUv6F {
	margin-top: 30px !important;
}
.ListSettingsForm-spaceTop6-DnqoQ {
	margin-top: 36px !important;
}
.ListSettingsForm-spaceTop7-ZBglV {
	margin-top: 42px !important;
}
.ListSettingsForm-spaceTop8-uX6v1 {
	margin-top: 48px !important;
}
.ListSettingsForm-noMargin-azIwk {
	margin: 0px !important;
}
.ListSettingsForm-padding1-n0JzW {
	padding-bottom: 6px !important;
}
.ListSettingsForm-padding2-GGfX3 {
	padding-bottom: 12px !important;
}
.ListSettingsForm-padding3-_Svo2 {
	padding-bottom: 18px !important;
}
.ListSettingsForm-padding4-ZXSDz {
	padding-bottom: 24px !important;
}
.ListSettingsForm-padding5-ECtnp {
	padding-bottom: 30px !important;
}
.ListSettingsForm-padding6-FD1TM {
	padding-bottom: 36px !important;
}
.ListSettingsForm-padding7-QFaqa {
	padding-bottom: 42px !important;
}
.ListSettingsForm-paddingTop1-TKGim {
	padding-top: 6px !important;
}
.ListSettingsForm-paddingTop2-nXPka {
	padding-top: 12px !important;
}
.ListSettingsForm-paddingTop3-M00eU {
	padding-top: 18px !important;
}
.ListSettingsForm-paddingTop4-dbDuk {
	padding-top: 24px !important;
}
.ListSettingsForm-paddingTop5-m1NMy {
	padding-top: 30px !important;
}
.ListSettingsForm-paddingTop6-JsbMJ {
	padding-top: 36px !important;
}
.ListSettingsForm-paddingTop7-kSEXN {
	padding-top: 42px !important;
}
.ListSettingsForm-noPadding-Sv9Et {
	padding: 0px !important;
}
.ListSettingsForm-textBold-gOTqs {
	font-weight: 500 !important;
}
.ListSettingsForm-textBolder-kCrIo {
	font-weight: 700 !important;
}
.ListSettingsForm-textNormal-mcgMi {
	font-weight: normal !important;
}
.ListSettingsForm-spaceBottom20-UqThO {
	margin-bottom: 20px;
}
.ListSettingsForm-spaceBottom10-FllqW {
	margin-bottom: 10px;
}
.ListSettingsForm-marginNone-e6nyx {
	margin: 0;
}
.ListSettingsForm-spaceBottom15-WVh2b {
	margin-bottom: 15px;
}
.ListSettingsForm-marginTopNone-nWu0U {
	margin-top: 0;
}
.ListSettingsForm-spaceTop11-zBmtH {
	margin-top: 11px;
}
.ListSettingsForm-spaceTop21-smKAL {
	margin-top: 21px;
}
.ListSettingsForm-spaceTop20-cTtW6 {
	margin-top: 20px;
}
.ListSettingsForm-spaceTop10-yAwN6 {
	margin-top: 10px;
}
/*New Design Text Colors */
.ListSettingsForm-textDarkBlue-y_cfY {
	color: rgb(20, 39, 94) !important;
}
.ListSettingsForm-textLightBlue-igmwH {
	color: rgb(57, 87, 106) !important;
}
.ListSettingsForm-textLightSandleGreen-mgZK_ {
	color: rgb(76, 86, 41) !important;
}
.ListSettingsForm-textLightBrown-XzntV {
	color: rgb(115, 79, 33) !important;
}
.ListSettingsForm-textMediumMaroon-Ap3j9 {
	color: rgb(87, 37, 51) !important;
}
.ListSettingsForm-textBrown-pszCO {
	color: rgb(160, 47, 24) !important;
}
.ListSettingsForm-textMaroon-io7kt {
	color: rgb(155, 49, 67) !important;
}
.ListSettingsForm-textDarkBrown-T6kJT {
	color: rgb(83, 18, 16) !important;
}
.ListSettingsForm-textMediumBrown-zAV6V {
	color: rgb(142, 28, 10) !important;
}
.ListSettingsForm-textSkyBlue-BvdsQ {
	color: rgb(37, 117, 141) !important;
}
.ListSettingsForm-textGray-DLBpq {
	color: rgb(77, 65, 51) !important;
}
.ListSettingsForm-commonHeaderAdmin-xcW8p {
	position: fixed !important;
}
.ListSettingsForm-adminLayout-wpy2G {
	padding-top: 64px !important;
}
.ListSettingsForm-box-g8LmO h2 {
	font-size: 21px;
	font-weight: 600;
}
.ListSettingsForm-exportLink-YHBCd {
	margin-bottom: -29px;
}
.ListSettingsForm-blockCenter-g5PTd {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}
.ListSettingsForm-panelHeader-DiQsk {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}
.ListSettingsForm-currencyselect-FgtUj {
	width: 100%;
	margin-right: 0px;
}
.ListSettingsForm-panelHeader-DiQsk {
	overflow: hidden;
	position: relative;
}
.ListSettingsForm-mar0-MpK02 {
	margin-left: 0;
	margin-right: 0;
}
@media screen and (max-width: 767px) {
	.ListSettingsForm-blockCenter-g5PTd {
		padding: 0px;
	}

	.ListSettingsForm-panelHeader-DiQsk {
		padding: 24px 5px;
	}
}
/** Admin - Common - Start **/
.ListSettingsForm-sideAdminPageWrapper-IXeK3 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}
.ListSettingsForm-panelHeader-DiQsk {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}
.ListSettingsForm-table-J96aC {
	display: table;
}
.ListSettingsForm-tableRow-pqJO6 {
	display: table-row;
}
.ListSettingsForm-tableCell-FHxox {
	display: table-cell;
	float: none;
}
.ListSettingsForm-formGroup-P4Fji {
	margin-bottom: 6px;
}
.ListSettingsForm-select-EexrY {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}
.ListSettingsForm-noMargin-azIwk {
	margin: 0px;
}
a,
a:hover {
	cursor: pointer;
}
.ListSettingsForm-exportLink-YHBCd {
	padding-top: 10px;
	padding-right: 10px;
}
.ListSettingsForm-labelTextNew-d1m73 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}
.ListSettingsForm-displayInline-W1kUB {
	display: inline-block;
}
/******************* Admin Modal ListSetting Start *******************/
.ListSettingsForm-btnUPdate-wjwkR {
	display: inline-block;
}
.ListSettingsForm-btnModalDelete-z9fTN {
	display: inline-block;
	margin-left: 15px;
}
.ListSettingsForm-radioBtn-Jkw_b {
	position: relative;
	top: 1px;
	vertical-align: middle;
}
.ListSettingsForm-backgroundImg-BYjmS {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}
@media screen and (max-width: 767px) {
	.ListSettingsForm-btnUPdate-wjwkR {
		display: block;
		margin-bottom: 12px;
	}

	.ListSettingsForm-btnModalDelete-z9fTN {
		display: block;
		margin-left: 0px;
	}

	.ListSettingsForm-btnWidth-Siick {
		width: 100%;
	}
}
/******************* Admin Modal ListSetting Start *******************/
/******************* Admin Banner Image Section Start ****************/
.ListSettingsForm-bannerImageBg-oYX_d {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}
.ListSettingsForm-bannerDelete-s16Wm {
	position: absolute;
	top: -12px;
	right: 4px;
}
/*******************Admin Modal Start **********************/
.ListSettingsForm-modalRoot-qeHSW {
	padding: 32px;
}
.ListSettingsForm-modalBorderBottom-lDCg6 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}
.ListSettingsForm-logInModalBody-NM65E {
	padding: 0px;
}
/*************** Admin TableNew Design Start**************************/
.ListSettingsForm-exportSection-BV2Vn {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}
.ListSettingsForm-exportSectionGridSub-alPD6 {
	grid-template-columns: 50% 49% !important;
}
.ListSettingsForm-exportText-V8BrF {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}
.ListSettingsForm-exportLinkImg-J0bh2 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}
.ListSettingsForm-vtrMiddle-ZshrY {
	vertical-align: middle;
}
.ListSettingsForm-exportImg-S3C4Z {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}
.ListSettingsForm-profileViewlabel-hzBbq {
	display: inline-block;
	width: 38%
}
.ListSettingsForm-profileViewMainContent-YOaZn {
	display: inline-block;
	width: 62%;
}
.ListSettingsForm-profileViewMain-nxBzQ {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.ListSettingsForm-profileViewInner-RNy8N {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}
.ListSettingsForm-profileImageSection-fR0D0 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}
.ListSettingsForm-lastviewInner-kipCq {
	padding: 10px;
}
.ListSettingsForm-whyHostHoriLine-R9nRP {
	margin: 30px 0;
}
.ListSettingsForm-tableGrid-BtEQr {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}
.ListSettingsForm-headingContent-K7izs {
	font-size: 18px;
	font-weight: 500;
}
.ListSettingsForm-refundTextColor-Um78_ {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}
.ListSettingsForm-dividerLine-Ro26Q {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}
.ListSettingsForm-smallContent-kEgl7 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}
@media (max-width: 1200px) and (min-width: 1024px) {
	.ListSettingsForm-sideAdminPageWrapper-IXeK3 {
		height: 100%;
		overflow: auto;
	}
}
@media (max-width:1199px) {
	.ListSettingsForm-sideAdminPageWrapper-IXeK3 {
		margin-left: 0;
	}
}
@media screen and (max-width: 991px) {
	.ListSettingsForm-exportSection-BV2Vn {
		grid-template-columns: 100%;
	}

	.ListSettingsForm-exportSectionGridSub-alPD6 {
		grid-template-columns: 100% !important;
	}

}
@media screen and (max-width: 767px) {
	.ListSettingsForm-profileViewlabel-hzBbq {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ListSettingsForm-profileViewMainContent-YOaZn {
		width: 100%;
		text-align: center;
	}
}
/*************** Admin TableNew Design End**************************/
.ListSettingsForm-ChangeToUpperCase-Txg3f {
	text-transform: uppercase
}
.ListSettingsForm-noBorder-TehEI {
	border: 0px !important;
}
/** Admin - Common - End **/
/* site Admin utility Start */
.ListSettingsForm-siteAdminHeading-V1CaL {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}
.ListSettingsForm-siteAdminSubHeading-briQi {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}
.ListSettingsForm-adminFormDivider-XDpuN {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;AC5NA;CACC,0BAA0B;AAC3B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,eAAe;AAChB;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;ACpDA,6BAA6B;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;;CAEC,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,qBAAqB;AACtB;AAEA,sEAAsE;AAEtE;CACC,qBAAqB;AACtB;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;AAEA,sEAAsE;AAEtE,sEAAsE;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;AAEA,4DAA4D;AAE5D;CACC,aAAa;AACd;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;AAEA;CACC,YAAY;AACb;AAEA,sEAAsE;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB;AACD;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,aAAa;AACd;AAEA;CACC,cAAc;AACf;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;AAEA;CACC;EACC,cAAc;CACf;AACD;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;AAEA,oEAAoE;AAEpE;CACC;AACD;AAEA;CACC,sBAAsB;AACvB;AAEA,2BAA2B;AAE3B,6BAA6B;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ListSettingsForm-errorMessage-sVfMa`,
	"space1": `ListSettingsForm-space1-Q30SZ`,
	"space2": `ListSettingsForm-space2-Pm2mg`,
	"space3": `ListSettingsForm-space3-GNNbd`,
	"space4": `ListSettingsForm-space4-Rg4fm`,
	"space5": `ListSettingsForm-space5-pYGR0`,
	"space6": `ListSettingsForm-space6-e7rEM`,
	"space7": `ListSettingsForm-space7-xnVyq`,
	"spaceTop8": `ListSettingsForm-spaceTop8-uX6v1`,
	"spaceTop1": `ListSettingsForm-spaceTop1-P0JbT`,
	"spaceTop2": `ListSettingsForm-spaceTop2-nMRDf`,
	"spaceTop3": `ListSettingsForm-spaceTop3-iQWyE`,
	"spaceTop4": `ListSettingsForm-spaceTop4-oX0Gy`,
	"spaceTop5": `ListSettingsForm-spaceTop5-vUv6F`,
	"spaceTop6": `ListSettingsForm-spaceTop6-DnqoQ`,
	"spaceTop7": `ListSettingsForm-spaceTop7-ZBglV`,
	"noMargin": `ListSettingsForm-noMargin-azIwk`,
	"padding1": `ListSettingsForm-padding1-n0JzW`,
	"padding2": `ListSettingsForm-padding2-GGfX3`,
	"padding3": `ListSettingsForm-padding3-_Svo2`,
	"padding4": `ListSettingsForm-padding4-ZXSDz`,
	"padding5": `ListSettingsForm-padding5-ECtnp`,
	"padding6": `ListSettingsForm-padding6-FD1TM`,
	"padding7": `ListSettingsForm-padding7-QFaqa`,
	"paddingTop1": `ListSettingsForm-paddingTop1-TKGim`,
	"paddingTop2": `ListSettingsForm-paddingTop2-nXPka`,
	"paddingTop3": `ListSettingsForm-paddingTop3-M00eU`,
	"paddingTop4": `ListSettingsForm-paddingTop4-dbDuk`,
	"paddingTop5": `ListSettingsForm-paddingTop5-m1NMy`,
	"paddingTop6": `ListSettingsForm-paddingTop6-JsbMJ`,
	"paddingTop7": `ListSettingsForm-paddingTop7-kSEXN`,
	"noPadding": `ListSettingsForm-noPadding-Sv9Et`,
	"textBold": `ListSettingsForm-textBold-gOTqs`,
	"textBolder": `ListSettingsForm-textBolder-kCrIo`,
	"textNormal": `ListSettingsForm-textNormal-mcgMi`,
	"spaceBottom20": `ListSettingsForm-spaceBottom20-UqThO`,
	"spaceBottom10": `ListSettingsForm-spaceBottom10-FllqW`,
	"marginNone": `ListSettingsForm-marginNone-e6nyx`,
	"spaceBottom15": `ListSettingsForm-spaceBottom15-WVh2b`,
	"marginTopNone": `ListSettingsForm-marginTopNone-nWu0U`,
	"spaceTop11": `ListSettingsForm-spaceTop11-zBmtH`,
	"spaceTop21": `ListSettingsForm-spaceTop21-smKAL`,
	"spaceTop20": `ListSettingsForm-spaceTop20-cTtW6`,
	"spaceTop10": `ListSettingsForm-spaceTop10-yAwN6`,
	"textDarkBlue": `ListSettingsForm-textDarkBlue-y_cfY`,
	"textLightBlue": `ListSettingsForm-textLightBlue-igmwH`,
	"textLightSandleGreen": `ListSettingsForm-textLightSandleGreen-mgZK_`,
	"textLightBrown": `ListSettingsForm-textLightBrown-XzntV`,
	"textMediumMaroon": `ListSettingsForm-textMediumMaroon-Ap3j9`,
	"textBrown": `ListSettingsForm-textBrown-pszCO`,
	"textMaroon": `ListSettingsForm-textMaroon-io7kt`,
	"textDarkBrown": `ListSettingsForm-textDarkBrown-T6kJT`,
	"textMediumBrown": `ListSettingsForm-textMediumBrown-zAV6V`,
	"textSkyBlue": `ListSettingsForm-textSkyBlue-BvdsQ`,
	"textGray": `ListSettingsForm-textGray-DLBpq`,
	"commonHeaderAdmin": `ListSettingsForm-commonHeaderAdmin-xcW8p`,
	"adminLayout": `ListSettingsForm-adminLayout-wpy2G`,
	"box": `ListSettingsForm-box-g8LmO`,
	"exportLink": `ListSettingsForm-exportLink-YHBCd`,
	"blockCenter": `ListSettingsForm-blockCenter-g5PTd`,
	"panelHeader": `ListSettingsForm-panelHeader-DiQsk`,
	"currencyselect": `ListSettingsForm-currencyselect-FgtUj`,
	"mar0": `ListSettingsForm-mar0-MpK02`,
	"sideAdminPageWrapper": `ListSettingsForm-sideAdminPageWrapper-IXeK3`,
	"table": `ListSettingsForm-table-J96aC`,
	"tableRow": `ListSettingsForm-tableRow-pqJO6`,
	"tableCell": `ListSettingsForm-tableCell-FHxox`,
	"formGroup": `ListSettingsForm-formGroup-P4Fji`,
	"select": `ListSettingsForm-select-EexrY`,
	"labelTextNew": `ListSettingsForm-labelTextNew-d1m73`,
	"displayInline": `ListSettingsForm-displayInline-W1kUB`,
	"btnUPdate": `ListSettingsForm-btnUPdate-wjwkR`,
	"btnModalDelete": `ListSettingsForm-btnModalDelete-z9fTN`,
	"radioBtn": `ListSettingsForm-radioBtn-Jkw_b`,
	"backgroundImg": `ListSettingsForm-backgroundImg-BYjmS`,
	"btnWidth": `ListSettingsForm-btnWidth-Siick`,
	"bannerImageBg": `ListSettingsForm-bannerImageBg-oYX_d`,
	"bannerDelete": `ListSettingsForm-bannerDelete-s16Wm`,
	"modalRoot": `ListSettingsForm-modalRoot-qeHSW`,
	"modalBorderBottom": `ListSettingsForm-modalBorderBottom-lDCg6`,
	"logInModalBody": `ListSettingsForm-logInModalBody-NM65E`,
	"exportSection": `ListSettingsForm-exportSection-BV2Vn`,
	"exportSectionGridSub": `ListSettingsForm-exportSectionGridSub-alPD6`,
	"exportText": `ListSettingsForm-exportText-V8BrF`,
	"exportLinkImg": `ListSettingsForm-exportLinkImg-J0bh2`,
	"vtrMiddle": `ListSettingsForm-vtrMiddle-ZshrY`,
	"exportImg": `ListSettingsForm-exportImg-S3C4Z`,
	"profileViewlabel": `ListSettingsForm-profileViewlabel-hzBbq`,
	"profileViewMainContent": `ListSettingsForm-profileViewMainContent-YOaZn`,
	"profileViewMain": `ListSettingsForm-profileViewMain-nxBzQ`,
	"profileViewInner": `ListSettingsForm-profileViewInner-RNy8N`,
	"profileImageSection": `ListSettingsForm-profileImageSection-fR0D0`,
	"lastviewInner": `ListSettingsForm-lastviewInner-kipCq`,
	"whyHostHoriLine": `ListSettingsForm-whyHostHoriLine-R9nRP`,
	"tableGrid": `ListSettingsForm-tableGrid-BtEQr`,
	"headingContent": `ListSettingsForm-headingContent-K7izs`,
	"refundTextColor": `ListSettingsForm-refundTextColor-Um78_`,
	"dividerLine": `ListSettingsForm-dividerLine-Ro26Q`,
	"smallContent": `ListSettingsForm-smallContent-kEgl7`,
	"ChangeToUpperCase": `ListSettingsForm-ChangeToUpperCase-Txg3f`,
	"noBorder": `ListSettingsForm-noBorder-TehEI`,
	"siteAdminHeading": `ListSettingsForm-siteAdminHeading-V1CaL`,
	"siteAdminSubHeading": `ListSettingsForm-siteAdminSubHeading-briQi`,
	"adminFormDivider": `ListSettingsForm-adminFormDivider-XDpuN`
};
module.exports = ___CSS_LOADER_EXPORT___;
